import React, {useEffect, useRef, useState} from 'react';
import * as PropTypes from 'prop-types';
import {ErrorMessage, InputWrapper, ModalHeaderInputStyled, TextMeasurer} from './ModalHeaderInput.styled';
import {EditIcon} from '../../design-icons';

export const ModalHeaderInput = ({
	cy,
	value,
	disabled,
	placeholder,
	onChange,
	hasError = false,
	errorMessage,
	autoFocus = false,
	maxLength = 191,
}) => {
	const textMeasurerRef = useRef();
	const [textWidth, setTextWidth] = useState(0);

	useEffect(() => {
		if (textMeasurerRef.current) {
			setTextWidth(textMeasurerRef.current.clientWidth);
		}
	}, [textMeasurerRef.current, value]);

	const handleChange = e => {
		onChange(e.target.value);
	};

	return (
		<div>
			<InputWrapper textWidth={textWidth}>
				<TextMeasurer ref={textMeasurerRef}>{value || placeholder}</TextMeasurer>
				<ModalHeaderInputStyled
					data-cy={cy}
					type="text"
					disabled={disabled}
					placeholder={placeholder}
					onChange={handleChange}
					value={value}
					autoFocus={autoFocus}
					maxLength={maxLength}
					autoComplete="off"
					className={hasError ? 'error' : ''}
					modalView={true}
				/>
				<EditIcon color="#8E8F9F" hoverColor={null} />
			</InputWrapper>
			{hasError && errorMessage ? <ErrorMessage data-cy={'error-message'}>{errorMessage}</ErrorMessage> : null}
		</div>
	);
};

ModalHeaderInput.propTypes = {
	/**
	 * Information when no value has been set yet.
	 */
	placeholder: PropTypes.string,
	/**
	 * Disable the input the user can't insert a new value or edit the current one.
	 */
	disabled: PropTypes.bool,
	/**
	 * Indicator to show that the input is in an invalid state
	 */
	hasError: PropTypes.bool,
	/**
	 * Error messages if input is invalid
	 */
	errorMessage: PropTypes.string,
	/**
	 * Value of the input
	 */
	value: PropTypes.string,
	/**
	 * This is necessary to get the value of the input from the parent
	 */
	onChange: PropTypes.func,
	/**
	 * Identifier for integration tests
	 */
	cy: PropTypes.string,
	/**
	 * Whether input field should auto focus when displaying (default: false)
	 */
	autoFocus: PropTypes.bool,
	/**
	 * Maximum length of input (default: 191)
	 */
	maxLength: PropTypes.number,
};
